import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import hhGaugeHelpImage from "../../assets/ui/help-hinder-gauge/hh-gauge-help.png";
import hhGaugeHinderImage from "../../assets/ui/help-hinder-gauge/hh-gauge-hinder.png";
import hhGaugeIndicatorImage from "../../assets/ui/help-hinder-gauge/hh-gauge-indicator.png";
import hhGaugeMarkerImage from "../../assets/ui/help-hinder-gauge/hh-gauge-marker.png";
import fistRedIcon from "../../assets/ui/icons/fist-red.png";
import heartGreenIcon from "../../assets/ui/icons/heart-green.png";

import "./HelpHinderGauge.scss";
import IconButton from "../IconButton/IconButton.js";

const HelpHinderGauge = ({
  totalVotes,
  helpPercentage,
  hinderPercentage,
  vote,
  onVote,
}) => {
  const { t } = useTranslation();

  const shouldHideIndicator =
    helpPercentage >= 0.98 || hinderPercentage >= 0.98;

  return (
    <div className="hh-gauge-container">
      <IconButton
        icon={heartGreenIcon}
        isActive={vote === "help"}
        onClick={() => onVote("help")}
      />
      <div className="hh-gauge">
        <div className="hh-gauge__inner">
          <img className="hh-gauge__marker" src={hhGaugeMarkerImage} alt="" />
          <img
            className="hh-gauge__indicator"
            src={hhGaugeIndicatorImage}
            alt=""
            style={{
              left: `calc(${helpPercentage * 100}% - 3px)`,
              opacity: shouldHideIndicator ? 0 : 1,
            }}
          />
          <img className="hh-gauge__image" src={hhGaugeHelpImage} alt="" />
          <img
            className="hh-gauge__image"
            src={hhGaugeHinderImage}
            alt=""
            style={{
              clipPath: `inset(0px 0px 0px ${(1 - hinderPercentage) * 100}%)`,
            }}
          />
        </div>
        <div
          className={classNames("hh-gauge__vote-count", {
            "hh-gauge__vote-count--help": helpPercentage > hinderPercentage,
            "hh-gauge__vote-count--hinder": helpPercentage < hinderPercentage,
          })}
        >
          {t("features.helpOrHinder.hhVotingFlyout.voteCount", {
            amount: totalVotes,
          })}
        </div>
      </div>
      <IconButton
        icon={fistRedIcon}
        isActive={vote === "hinder"}
        onClick={() => onVote("hinder")}
      />
    </div>
  );
};

export default HelpHinderGauge;
